// Where an Academy notification leads. The backend (edu/notify.py) stores a short reference in notifications.ticker:
// '1624' (a class or an item id) or '1624.88' (class 1624 + an item/person). Used by the bell and the alerts tab.
const cls = (id, q = '') => `/app/edu/classes/${id}${q}`;
const split = (ref) => String(ref || '').split('.');

const EDU_ROUTES = {
  // students
  edu_assignment: (r) => cls(r, '?tab=assignments'),
  edu_assignment_done: (r) => cls(r, '?tab=assignments'),
  edu_class_lesson: (r) => `/app/edu/lesson/${r}`,
  edu_class_challenge: (r) => `/app/edu/challenge/${r}`,
  edu_live: (r) => `/app/edu/live/${r}`,
  edu_announcement: (r) => cls(r),
  edu_staff_nudge: (r) => cls(r),
  edu_class_plan: (r) => cls(r, '?tab=together'),
  edu_class_script: (r) => cls(r, '?tab=scripts'),
  edu_partner_nudge: (r) => cls(r, '?tab=partner'),
  edu_review_reply: (r) => { const [c, id] = split(r); return cls(c, `?tab=reviews&review=${id}`); },
  edu_consent_request: (r) => cls(r, '?tab=settings'),
  edu_question_reply: (r) => cls(split(r)[0], '?messages=me'),
  edu_certificate: (r) => `/app/edu/cert/${r}`,
  edu_chart_feedback: (r) => `/app/edu/study/${split(r)[1]}`,
  edu_waitlist_joined: (r) => cls(r),
  edu_waitlist_seat: (r) => cls(r),
  // both sides of a conversation: '<class>.<the other person>' or '<class>.c' for the class chat
  edu_message: (r) => { const [c, who] = split(r); return cls(c, `?messages=${who}`); },
  edu_class_chat: (r) => cls(split(r)[0], '?messages=class'),
  edu_class_question: (r) => cls(split(r)[0], '?messages=qa'),
  // educators
  edu_question: (r) => { const [c, who] = split(r); return cls(c, `?messages=${who}`); },
  edu_review_request: (r) => { const [c, id] = split(r); return cls(c, `?tab=reviews&review=${id}`); },
  edu_joined: (r) => cls(r, '?tab=roster'),
  edu_consent_answer: (r) => { const [c, who] = split(r); return cls(c, `?tab=roster&student=${who}`); },
  edu_left: (r) => cls(r, '?tab=roster'),
  edu_assignment_progress: (r) => cls(split(r)[0], '?tab=assignments'),
  edu_chart_submitted: (r) => `/app/edu/study/${split(r)[1]}`,
  edu_lesson_done: (r) => `/app/edu/lesson/${r}`,
  edu_challenge_played: (r) => `/app/edu/challenge/${r}`,
  // educator brand, store, community, engagement (migrations 125-131)
  edu_win: () => '/app/edu/teach?tab=community',
  edu_win_approved: (r) => `/app/edu/e/${encodeURIComponent(r)}#wins`,
  edu_update: (r) => `/app/edu/e/${encodeURIComponent(r)}#updates`,
  edu_team: () => '/app/edu/teach?tab=community',
  edu_team_invite: () => '/app/edu/store/mine#invites',
  edu_reward: () => '/app/edu/store/mine#rewards',
  edu_tier: () => '/app/edu/store/mine',
  edu_booking: () => '/app/edu/teach?tab=store',
  edu_booking_canceled: () => '/app/edu/store/mine',
  edu_article: (r) => `/app/edu/a/${r}`,
  edu_launch: (r) => cls(r),
  edu_drip: (r) => {
    const k = String(r)[0]; const v = String(r).slice(1);
    if (k === 'L') return `/app/edu/lesson/${v}`;
    if (k === 'A') return `/app/edu/a/${v}`;
    if (k === 'P') return `/app/edu/e/${encodeURIComponent(v)}#shop`;
    if (k === 'T') return `/app/edu/e/${encodeURIComponent(v)}#memberships`;
    return cls(v);
  },
};
const NO_REF = { edu_digest: '/app/edu', edu_invite: '/app/edu/teach', edu_alert: '/app/edu', edu_partner: '/app/edu/teach?tab=partner' };

/** Page for an Academy notification, or null (not an Academy one, or an old one without a reference). */
export function eduRoute(n) {
  const t = n?.rule_type;
  if (!t || !t.startsWith('edu_')) return null;
  if (NO_REF[t]) return NO_REF[t];
  const f = EDU_ROUTES[t];
  return f && n.ticker ? f(n.ticker) : '/app/edu';
}
